import {TransportType, transportType} from '@ots-frontend/ots-data';
import {transportDefaultColor, transportDeliveryColor, transportPickupColor,} from '../theme/colors';
import * as CSS from 'csstype';

/**
 * Retrieves the color for the corresponding transport type.
 *
 * @param value The transport type.
 */
export const getTransportColorByType = (
  value: TransportType
): CSS.Property.Color => {
  switch (value) {
    case transportType.pickup:
      return transportPickupColor;
    case transportType.delivery:
      return transportDeliveryColor;
    default:
      return transportDefaultColor;
  }
};
